import {CALENDAR_DATES} from './GetCalendarDates';

export const Queries = {CALENDAR_DATES};
